export default "__VITE_ASSET__fm6nZapA__"